
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: "root",
})
export class CollaboratorService {
    constructor(private http: HttpClient) { }


    listCollaborators(id) {
        return this.http.get(
          `${environment.apiUrl}/trackvision/collaborators/list/${id}`,
          {
            headers: new HttpHeaders().set(
              "Token",
              localStorage.getItem("access_token") || ""
            ),
          }
        );
      }

    //#region Obtener Colaboradores TODO: vALIDAR CON NATALIA
    getAllCollaboratorsData() {
        return this.http.get(`${environment.apiUrl}/trackvision/requirement/activityalert/getcollaborator`,
            {
                headers: new HttpHeaders().set("Token", localStorage.getItem("access_token") || ""),
            }
        );
    }
    //#endregion

    //#region Guardar Colaboradores suscritos al requerimiento
    addCollaborator(body) {
        return this.http.post(`${environment.apiUrl}/trackvision/requirement/suscribe`, body,
            {
                headers: new HttpHeaders().set("Token", localStorage.getItem("access_token") || ""),
            }
        );
    }
    //#endregion

    //#region Eliminar Colaborador suscrito al requerimiento
    deleteCollaborator(body) {
        return this.http.post(`${environment.apiUrl}/trackvision/requirement/deletesubscribed`, body,
            {
                headers: new HttpHeaders().set("Token", localStorage.getItem("access_token") || ""),
            }
        );
    }
    //#endregion

}